<template>
  <avs-card>
    <template v-slot:title>
      <v-toolbar
        class="mt-4 custom-toolbar"
        elevation="0"
      >
        <v-text-field
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
          :label="$t('commons.search')"
          v-model="search"
        />
        <slot
          name="actions"
          v-bind:dataset="dataset"
        />
      </v-toolbar>
    </template>
    <template v-slot:content>
      <v-data-table
        class="ma-10"
        disable-pagination
        :no-data-text="$t('messages.information.no_data')"
        :headers="headers"
        hide-default-footer
        :items="dataset"
        :loading="loading"
        loading-text="Loading Pcq/Dsi"
        no-results-text="No Pcq/Dsi found"
        :search="search"
        @dblclick:row="($event, { item }) => toEdit(item)"
      >
        <template v-slot:item.task.name="{ item }">
          {{ getTaskName(item) }}
        </template>

        <template v-slot:item.performer="{ item }">
          <avs-chip
            class="min-width-120"
            color="info"
            iconColor="blue"
            text-color="blue"
            v-if="item.performer"
          >
            Signed
          </avs-chip>
          <template v-else>
            {{ $t("/") }}
          </template>
          <!-- <template v-else>
            {{ $t("/") }}
          </template> -->
        </template>
        <template v-slot:item.quality_control="{ item }">
          <avs-chip
            class="min-width-120"
            color="info"
            iconColor="blue"
            text-color="blue"
            v-if="item.quality_control"
          >
            Signed
          </avs-chip>
          <template v-else>
            {{ $t("/") }}
          </template>
          <!-- <avs-chip
            class="min-width-120"
            color="warning"
            iconColor="blue"
            text-color="blue"
            v-else
          >
            Not Signed
          </avs-chip> -->
        </template>
        <template v-slot:item.technical_control="{ item }">
          <avs-chip
            class="min-width-120"
            color="info"
            iconColor="blue"
            text-color="blue"
            v-if="item.technical_control"
          >
            Signed
          </avs-chip>
          <template v-else>
            {{ $t("/") }}
          </template>
        </template>
        <template v-slot:item.part_a="{ item }">
          <avs-chip
            class="min-width-120"
            color="info"
            iconColor="blue"
            text-color="blue"
            v-if="item.part_a"
          >
            Signed
          </avs-chip>
          <template v-else>
            {{ $t("/") }}
          </template>
        </template>
        <template v-slot:item.part_b="{ item }">
          <avs-chip
            class="min-width-120"
            color="info"
            iconColor="blue"
            text-color="blue"
            v-if="item.part_b"
          >
            Signed
          </avs-chip>
          <template v-else>
            {{ $t("/") }}
          </template>
        </template>
        <template v-slot:item.part_c="{ item }">
          <avs-chip
            class="min-width-120"
            color="info"
            iconColor="blue"
            text-color="blue"
            v-if="item.part_c"
          >
            Signed
          </avs-chip>
          <template v-else>
            {{ $t("/") }}
          </template>
        </template>
        <template v-slot:item.part_d="{ item }">
          <avs-chip
            class="min-width-120"
            color="info"
            iconColor="blue"
            text-color="blue"
            v-if="item.part_d"
          >
            Signed
          </avs-chip>
          <template v-else>
            {{ $t("/") }}
          </template>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-end">
            <avs-editButton
              v-if="!pcqDsiIsConfirm"
              :to="getToEditLink(item)"
              :spantext="
                $t('actions.edit', { entity: $tc('categories.pcqdsi.name', 1).toLowerCase() })
              "
            />
            <avs-deleteButton
              v-if="!pcqDsiIsConfirm"
              @click="handleOpenDeleteDialog(item)"
              :spantext="
                $t('actions.delete', { entity: $tc('categories.pcqdsi.name', 1).toLowerCase() })
              "
            />
          </div>
        </template>
      </v-data-table>
      <avs-deleteDialog
        v-model="deleteDialogIsOpen"
        @cancel="handleCancel"
        @delete="handleDelete"
        resource="pcq/dsi"
      />
    </template>
  </avs-card>
</template>

<script>
import { PcqDsiService } from "@/services"
import { toDatetime } from "@/utils/datetime"

export default {
  name: "PcqDsisTable",
  props: {
    pcqDsiIsConfirm: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    project() {
      return this.$store.state.app.project
    }
  },
  data() {
    return {
      dataset: [],
      deleteDialogIsOpen: false,
      document: null,
      headers: [
        { text: "Task", value: "task.name", class: "min-width-200", sortable: false },
        { text: "Doc. Rev.", value: "doc_rev", class: "min-width-150", sortable: false },
        { text: "Performer", value: "performer", class: "min-width-150", sortable: false },
        { text: "Quality Control", align: "center", value: "quality_control", sortable: false },
        {
          text: "Technical Control Performer",
          sortable: false,
          value: "technical_control"
        },
        { text: "Quality point", align: "center", value: "quality_point_a", sortable: false },
        { text: "Partie A", align: "center", value: "part_a", sortable: false },
        { text: "Quality point", align: "center", value: "quality_point_b", sortable: false },
        { text: "Partie B", align: "center", value: "part_b", sortable: false },
        { text: "Quality point", align: "center", value: "quality_point_c", sortable: false },
        { text: "Partie C", align: "center", value: "part_c", sortable: false },
        { text: "Quality point", align: "center", value: "quality_point_d" },
        { text: "Partie D", align: "center", value: "part_d", sortable: false },
        { text: "Record required", align: "center", value: "record", sortable: false },
        { text: "Record reference", align: "center", value: "reference", sortable: false },
        {
          text: "NCR/DR other observation",
          align: "center",
          value: "observation",
          sortable: false
        },
        {
          text: "Actions",
          sortable: false,
          value: "actions",
          align: "right",
          width: 200
        }
      ],
      loading: false,
      search: "",
      selectedItem: null,
      template: null,
      values: null
    }
  },
  methods: {
    toDatetime,
    getDataset() {
      this.loading = true
      PcqDsiService.get(this, this.project.id)
        .then(response => {
          this.dataset = response.results
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            // alert("Access denied: You do not have permission to access this resource.")
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    getToEditLink(item) {
      return {
        name: "PcqDsiCreateUpdate",
        params: { id: item.id }
      }
    },
    getTaskName(item) {
      return item.task.name ? item.task.name : item.name.toUpperCase()
    },
    handleOpenDeleteDialog(item) {
      this.deleteDialogIsOpen = true
      this.selectedItem = item
    },
    handleCancel() {
      this.deleteDialogIsOpen = false
    },
    handleDelete(item) {
      PcqDsiService.remove(this, this.selectedItem.id)
        .then(r => {
          this.dataset = this.dataset.filter(nc => nc.id !== this.selectedItem.id)
          this.$store.commit("app/message", {
            msg: this.$t("messages.success.deleted", {
              entity: this.$tc("categories.pcqdsi.name", 1)
            }),
            color: "success"
          })
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            // alert("Access denied: You do not have permission to access this resource.")
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
      this.deleteDialogIsOpen = false
    },
    handleStatusComponent(task) {
      return task.status
    },
    isMettingDisabled(item) {
      return item.status === "Closed"
    },
    toEdit(item) {
      this.$router.push(this.getToEditLink(item))
    }
  },
  mounted() {
    this.getDataset()
  }
}
</script>

<style scoped>
.custom-toolbar >>> .v-toolbar__content {
  gap: 1rem;
}
</style>
